import { Component, Input } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-sortable-list[items][labelField]',
  templateUrl: './bary-sortable-list.component.html',
  styleUrls: ['./bary-sortable-list.component.scss'],
})
export class BarySortableListComponent {
  @Input() items: FormArray | any[] = [];
  @Input() labelField!: string;
  @Input() showPosition = false;

  protected readonly FAS = FaDirectiveEnum.FAS;

  options = {
    draggable: '.draggable',
    scroll: true,
    scrollSensitivity: 100,
  };

  getItems(): any[] {
    if (this.items instanceof FormArray) {
      return this.items.controls;
    } else {
      return this.items;
    }
  }

  getItemLabel(item: any): string {
    if (item instanceof AbstractControl) {
      return item.value[this.labelField] as string;
    } else {
      return item[this.labelField] as string;
    }
  }
}
